export const validation = {
  headingMaxChar: 60,
  paragraphMaxChar: 600,
  title: { required: true },
  buttons: {
    min: 0,
    max: 2
  }
}
